// Hand-strength ladder, draw flags, board texture + events.
// ENGINE_DESIGN.md §4.4, §6.2 (heroHandClass min/max), §8; ARCHITECTURE.md §5.
import { z } from 'zod';
import { RankClassSchema } from './rank-class';
/** The value-strength ladder, weakest → strongest. This ordering is the SINGLE SOURCE OF TRUTH
 *  for the `min` / `max` bounds an ExploitRule.when uses (ENGINE_DESIGN.md §6.2). Draws sort below
 *  made pairs: a rule with `max: 'overpair'` means "one pair or worse, draws included"; a rule with
 *  `min: 'top_pair_good_kicker'` targets strong made hands and excludes draws. */
export const HAND_CLASS_ORDER = [
    'air',
    'ace_high',
    'weak_draw',
    'strong_draw',
    'weak_pair',
    'second_pair_good_kicker',
    'top_pair_weak_kicker',
    'top_pair_good_kicker',
    'top_pair_top_kicker',
    'overpair',
    'two_pair',
    'set',
    'straight',
    'flush',
    'full_house',
    'quads',
    'straight_flush',
];
export const HandClassSchema = z.enum(HAND_CLASS_ORDER);
/** Rank of a hand class in the ladder (0 = weakest). Downstream min/max comparisons use this. */
export const handClassRank = (hc) => HAND_CLASS_ORDER.indexOf(hc);
export const DRAW_FLAGS = [
    'flush_draw',
    'nut_flush_draw',
    'oesd',
    'gutshot',
    'double_gutshot',
    'overcards',
    'backdoor_flush',
    'backdoor_straight',
    'combo_draw',
];
export const DrawFlagSchema = z.enum(DRAW_FLAGS);
/** Overall board texture label (ARCHITECTURE.md §5 board.textureClass). */
export const TEXTURE_CLASSES = [
    'dry',
    'semi_wet',
    'wet',
    'paired',
    'two_tone',
    'monotone',
    'connected',
    'disconnected',
];
export const TextureClassSchema = z.enum(TEXTURE_CLASSES);
/** A classified street card event - how a new board card crosses to the coach as a conclusion,
 *  never as a raw card string (ARCHITECTURE.md §5, rule 2). */
export const BoardEventKindSchema = z.enum([
    'blank',
    'overcard',
    'undercard',
    'pairs_board',
    'flush_card',
    'completes_flush',
    'straight_card',
    'completes_straight',
    'two_tone',
]);
export const BoardEventSchema = z.object({
    kind: BoardEventKindSchema,
    rankClass: RankClassSchema.optional(),
    completesFlush: z.boolean(),
    pairsBoard: z.boolean(),
});
//# sourceMappingURL=hand-class.js.map